var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudComputing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cloud-computing",
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.979,
    height: 32,
    viewBox: "0 0 43.979 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33198",
    "data-name": "Group 33198"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70454",
    "data-name": "Path 70454",
    d: "M34.363,98.65H24.928V89.116h3.118a.975.975,0,0,0,.791-1.546l-6.066-8.393a.967.967,0,0,0-1.573,0L15.133,87.57a.973.973,0,0,0,.791,1.546h3.118V98.65H8.474C3.756,98.389,0,93.977,0,89.2a8.952,8.952,0,0,1,4.439-7.728,6,6,0,0,1-.368-2.094,6.086,6.086,0,0,1,6.093-6.093,5.989,5.989,0,0,1,2.085.368,12.2,12.2,0,0,1,23.176,4.026,10.611,10.611,0,0,1-1.06,20.974Z",
    transform: "translate(0 -66.65)",
    fill: "#5076ba"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudComputing);
export default __webpack_public_path__ + "static/media/cloud-computing.7a102fb66305789d8a2075d0be5c7f0b.svg";
export { ForwardRef as ReactComponent };